<template>
    <div class="relative w-full">
        <form
            @submit.prevent="subscribe()"
            class="relative flex w-full pt-1 bg-white border rounded-md overflow-hidden transition"
            :class="focus ? 'border-indigo-lighter' : 'border-pink'"
        >
            <input
                v-model="email"
                @focus="focus = true"
                @blur="focus = false"
                class="flex-1 text-xs sm:text-sm text-grey placeholder:text-grey-light font-bold uppercase leading-none tracking-wide focus:outline-none pl-3 md:pl-6 py-6"
                type="email"
                name="EMAIL"
                value=""
                placeholder="Email Address"
                required
            />

            <button class="focus:outline-none group" type="submit">
                <div
                    class="text-xs sm:text-sm text-grey group-hover:text-red font-bold uppercase leading-none tracking-wide pl-8 pr-3 md:pr-6 py-6 transition"
                >
                    Submit &rarr;
                </div>
            </button>
        </form>

        <div
            class="absolute inset-0 flex justify-center items-center w-full h-full bg-white border-2 border-green rounded-md text-xs sm:text-sm lg:text-base font-bold transition-quad"
            :class="response > '' ? 'opacity-100 visible' : 'opacity-0 invisible'"
        >
            <p class="mt-1 text-green-dark">
                {{ response }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: ['mailingList'],
    data() {
        return {
            email: '',
            focus: false,
            response: '',
        }
    },
    methods: {
        subscribe() {
            $.ajax({
                url: winshape.ajaxurl,
                type: 'POST',
                data: {
                    action: 'newsletter',
                    email: this.email,
                    list: this.mailingList,
                },
            })
                .done(data => {
                    this.response = data
                })
                .fail(() => {
                    console.log(`API request didn't load!`)
                })
        },
    },
}
</script>
